import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const userKeys = new QueryKeyFactory('user')

